import { CarouselViewEntered, ChangedCurrentCarouselFile } from '../carouselViewer/actions'
import type { Action } from '../common/actions'

import { LastSeenAlbumUpdated, LastSeenElementCleared, LastSeenElementUpdated } from './actions'

export type LastSeenElementState = {
    activeFile: DictionaryOf<FileID | undefined>
    currentAlbum: JobID | undefined
}

const initialState: LastSeenElementState = {
    activeFile: {},
    currentAlbum: undefined,
}

export const lastSeenElementReducer = (
    state: LastSeenElementState = initialState,
    action: Action,
): LastSeenElementState => {
    if (
        LastSeenElementUpdated.match(action) ||
        CarouselViewEntered.match(action) ||
        ChangedCurrentCarouselFile.match(action)
    ) {
        return {
            ...state,
            activeFile: {
                ...state.activeFile,
                [action.payload.jobID]: action.payload.fileID,
            },
        }
    }

    if (LastSeenElementCleared.match(action)) {
        return {
            ...state,
            activeFile: {
                ...state.activeFile,
                [action.payload]: undefined,
            },
        }
    }
    if (LastSeenAlbumUpdated.match(action)) {
        return {
            ...state,
            currentAlbum: action.payload,
        }
    }

    return state
}

export const lastSeenElementReducerMapObj = {
    lastSeenElement: lastSeenElementReducer,
}

export type StateWithLastSeenElement = StateOfReducerMapObj<typeof lastSeenElementReducerMapObj>
